<div class="not-found"*ngIf="!contentNotFound; else elseBlock">
    <h2>{{'CP_LM_PAGENOTFOUND_MESSAGE' | translate }}</h2>
</div>
<ng-template #elseBlock>
    <div class="main-container">
        <div class="content-position">
            <h2>{{'CP_CONTENT_NOT_FOUND' | translate}}</h2>
            <div class="button-region center">
              <button class="primary" (click)="refreshPage()">
                {{'CP_REFRESH_BTN' | translate}}
              </button>
            </div>
          </div>
    </div>
    
  </ng-template>